import ViewUI from 'view-design'
import i18n from '../main'
import { session, cookie } from '@/libs/location'
import router from '@/router'
/**
 * @description 异常处理
 * @param 接口返回异常code
 */
export const handleCode = (code, message) => {
  switch (code) {
    case '9997':
      ViewUI.Modal.warning({
        title: i18n.t('jg'),
        content: i18n.t('interface.dlsxqcxdl'),
        onOk () {
          session.clear()
          let car = ['dlcd.dolinkhub.com','localhost:8080']
          let cookieName = ''
          if (car.indexOf(window.location.host) !== -1) {
            cookieName = `token${window.document.location.href.split('/')[3]}`
          } else {
            cookieName = 'token'
          }
          cookie.removeCookie(cookieName)
          cookie.removeCookie('userInfo')
          // 重新登录
          router.replace({ path: '/login' })
        }
      })
      break;
    case '10033':
      ViewUI.Modal.warning({
        title: i18n.t('jg'),
        content: '<p> + 登录密码还有%s天过期，请及时修改密码 + </p>',
        onOk () {}
      })
      break;
    default:
      ViewUI.Notice.error({
        title: i18n.t('cw'),
        // desc: i18n.t(`interface.${code}`)
        desc: message
      })
      break;
  }
}
